/**
 * Shared text constants for forms
 */

// text constants for the LLM query access switch on the signup page
export const LLM_QUERY_ACCESS_SIGNUP = {
  LABEL: 'Allow LLMs to access database query results',
  DESCRIPTION: 'Decide whether LLMs can access database query results',
  TOOLTIP_MESSAGES: [
    'Database query results are never stored and your data is never trained on.',
    '', // empty string to add a line break
    'Allowing third-party LLMs (e.g., Anthropic, Google, OpenAI) to access database query results enables capabilities like result summarization, better follow-up questions, and more natural explanations.',
    '', // empty string to add a line break
    'You can edit this setting later.'
  ],
  ENABLED_TEXT: 'Enable LLM query result access',
  DISABLED_TEXT: 'Disable LLM query result access',
  DATA_TEST: 'newKnowledgeGraphLlmDataAccess'
};
